export default {
  id: "page11",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",
  questions: [
    {
      type: "justlabel",
      number: "24",
      label:
        "Jak często jada Pan(i) następujące <span class='has-text-danger'>produkty mrożone</span>?",
      info:
        "Dla każdego produktu (w wierszu) proszę zaznaczyć jedną odpowiedź pod odpowiednią częstotliwością."
    },
    {
      type: "choice_names",
      options: [
        "Raz w tygodniu lub częściej",
        "1-2 razy w miesiącu",
        "Raz na 2-3 miesiące",
        "Rzadziej",
        "Wcale"
      ],
      topLine: true,
      bottomLine: true
    },
    {
      label: "Pizza mrożona",
      type: "radio",
      id: "kategoria6_pizza",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Zapiekanka mrożona",
      type: "radio",
      id: "kategoria6_zapiekanka",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Inne snacki mrożone",
      type: "radio",
      id: "kategoria6_snacki",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Bułki mrożone do odpieku w domu",
      type: "radio",
      id: "kategoria6_bulkiOdpiek",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Słodkie wypieki mrożone do odpieku w domu (np. croissanty itp.)",
      type: "radio",
      id: "kategoria6_slodkieWypiekiOdpiek",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page11.js